import { HTTP_POST, WebApiRequest } from "tools/webservice";

export const runBulkAutoQAProcess = (payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: "/field-service-auto-qa/add-batch",
  payload,
  successCallback,
  mountedRef,
});
